module.exports = __webpack_public_path__ + "static/img/customs_banner_iphone.ab11eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customs_banner_iphone.png
// module id = ReMf
// module chunks = 1